var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SpectrumZoomEvent } from "./events.js";
import { Zoom, DefaultZoom } from "../coordinates/zoom.js";
import * as Icons from "../icons.js";
import { BaseStyle } from "../styles.js";
let RrZoombar = class RrZoombar extends LitElement {
    constructor() {
        super(...arguments);
        this.zoom = DefaultZoom;
    }
    static get styles() {
        return [
            BaseStyle,
            css `
        :host {
          display: flex;
          flex-direction: row;
        }

        #zoomInput {
          width: 6ex;
        }
      `,
        ];
    }
    render() {
        return html `<button @click=${this.onClickMinus}>${Icons.ZoomOut}</button>
      <input
        id="zoomInput"
        type="text"
        .value=${getDisplayZoomValue(this.zoom.level)}
        @focus=${this.onZoomFocus}
        @blur=${this.onZoomBlur}
        @change=${this.onZoomChange}
      />
      <button @click=${this.onClickPlus}>${Icons.ZoomIn}</button>`;
    }
    onZoomFocus(e) {
        let target = e.target;
        target.value = getInputZoomValue(this.zoom.level);
    }
    onZoomBlur(e) {
        let target = e.target;
        target.value = getDisplayZoomValue(this.zoom.level);
    }
    onZoomChange(e) {
        let target = e.target;
        let value = target.value;
        if (value.endsWith("x"))
            value = value.substring(0, value.length - 1);
        let input = Number(value);
        if (isNaN(input)) {
            target.value = getDisplayZoomValue(this.zoom.level);
        }
        else {
            this.setZoom(input);
        }
    }
    onClickMinus() {
        this.setZoom(this.zoom.level / Math.sqrt(2));
    }
    onClickPlus() {
        this.setZoom(this.zoom.level * Math.sqrt(2));
    }
    setZoom(level) {
        if (Math.abs(level - Math.round(level)) < 0.01) {
            level = Math.round(level);
        }
        let zoom = this.zoom;
        if (this.highlight?.point !== undefined) {
            // If the highlight appears within the visible area, endeavor to keep it in the same relative screen position.
            zoom = zoom.withLevelInContext(level, this.highlight.point);
        }
        else {
            zoom = zoom.withLevel(level);
        }
        this.zoom = zoom;
        this.dispatchEvent(new SpectrumZoomEvent(zoom));
    }
};
__decorate([
    property({ attribute: false }),
    __metadata("design:type", typeof (_a = typeof Zoom !== "undefined" && Zoom) === "function" ? _a : Object)
], RrZoombar.prototype, "zoom", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Object)
], RrZoombar.prototype, "highlight", void 0);
RrZoombar = __decorate([
    customElement("rr-zoombar")
], RrZoombar);
export { RrZoombar };
function getDisplayZoomValue(value) {
    return getInputZoomValue(value) + "x";
}
function getInputZoomValue(value) {
    return String(Math.round(value * 100) / 100);
}
